import { render, staticRenderFns } from "./Absolutely.vue?vue&type=template&id=bab1234c&scoped=true&"
import script from "./Absolutely.vue?vue&type=script&lang=js&"
export * from "./Absolutely.vue?vue&type=script&lang=js&"
import style0 from "./Absolutely.vue?vue&type=style&index=0&id=bab1234c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1234c",
  null
  
)

export default component.exports